// Fire-and-forget admin Telegram pings (backend /notify/* endpoints).
// Never throws, never blocks the caller — a failed notify must not affect
// signup or dashboard load. The backend re-checks auth and, for the
// dashboard ping, skips admins and throttles per user.
import { auth } from '../firebase-config';
import { API_BASE } from './apiBase';

async function ping(path, body = {}) {
  try {
    const user = auth.currentUser;
    if (!user) return;
    const idToken = await user.getIdToken();
    await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
      keepalive: true,
    });
  } catch (e) {
    console.warn('adminNotify failed (non-fatal):', path, e);
  }
}

export const notifyNewUser = (name = '') => ping('/notify/new-user', { name });
export const notifyDashboardVisit = () => ping('/notify/dashboard-visit');

export async function captureUseCase(sessionId, problemText, sector = '') {
  try {
    const user = auth.currentUser;
    if (!user) return false;
    const idToken = await user.getIdToken();
    const res = await fetch(`${API_BASE}/capture-use-case`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ sessionId, problemText, sector }),
      keepalive: true,
    });
    return res.ok;
  } catch (e) {
    console.warn('captureUseCase failed (non-fatal):', e);
    return false;
  }
}

// Firebase ID token of the signed-in user, or null (signed out / refresh
// failed). Lets callers that work for anonymous users too (e.g. /retrieve)
// attach auth only when there is some.
export async function currentIdToken() {
  try {
    const user = auth.currentUser;
    return user ? await user.getIdToken() : null;
  } catch (e) {
    return null;
  }
}
